import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import moment from 'moment';

import helpers from '../helpers';

import Logo from '../../../assets/images/truelark_icon.svg';
import Profile from '../../Header/img/profile.png'
import Ellipse from '../../../assets/images/Ellipse.svg';
import Line from '../../../assets/images/Line.svg';
import optout_1 from '../../../assets/images/optout_1.svg';
import optout_2 from '../../../assets/images/optout_2.svg';
import closeBlue from '../../../assets/images/close_icon_blue.svg';
import Voicecall from '../../../assets/images/lucide_audio-lines.svg';
import './index.scss';
import utils from '../../../lib/utils';

const getLocalTimeFromNow = (conversation)=>{
    let timestamp = conversation.endTime>0?conversation.endTime:conversation.startTime;
    let localtime = new Date(timestamp);
    let conversationDate = moment(localtime).endOf('day').format('LLLL');
     if(moment().startOf('day').diff(localtime,'days')===0){
       return moment( localtime ).calendar( null, {
           sameDay: 'hh:mm a [Today]',
           lastDay: 'hh:mm a [Yesterday]',        
         });
     }else{
        conversationDate = moment(localtime).format('LLLL');
        return moment(conversationDate).fromNow();
     }
  }
const isTransitoned=(conversationid,transitionlist)=>{
    if(conversationid && transitionlist && transitionlist.length>0){
        const currentElement = transitionlist.filter(conversation=>conversationid===conversation.id);
        return currentElement.length>0?true:false;
    }else{
        return false;
    }
}
const getStaffName=(staff_id, StaffManagement)=>{
    const assignedStaff = StaffManagement.list.filter(staff=>staff.id===staff_id);
    if(assignedStaff && assignedStaff.length>0){
        return assignedStaff[0].firstName+' '+assignedStaff[0].lastName;
    }else {
        return 'staff'
    }
}
const getTransitionMessage=(conversation,markResolved,assignmentData,StaffManagement,auth, allAssignmentMap, addOnNotEnabled)=>{
    if(!addOnNotEnabled){
        if(conversation && conversation.id===markResolved){
            const currentAssignment = allAssignmentMap.filter(assignment=>assignment.assigned_user===conversation.userId)
            if(currentAssignment && currentAssignment.length>0){
                return 'Resolved and no longer needs attention';
            }else{
                return 'Resolved and no longer needs attention';
            }
        }else if(assignmentData && !utils.isEmptyObject(assignmentData)){
            if(!assignmentData.assigned_to){
                if(assignmentData.was_assigned_to===auth.userid){
                    if(assignmentData.assigned_by===auth.userid){
                        if(conversation.action==='FOLLOWUP_NEEDED'){
                            return 'Moved to Unassigned';
                        }
                        return 'Auto Response activated';
                    }else{
                        return 'Auto Response activated by '+getStaffName(assignmentData.assigned_by, StaffManagement);
                    }
                    
                }else{
                    return 'Auto Response activated by '+getStaffName(assignmentData.assigned_by, StaffManagement);
                }
                
            }else if(assignmentData.assigned_to===auth.userid){
                return 'Moved to Mine';
            }else if(assignmentData.assigned_to){
                if(assignmentData.was_assigned_to){
                    return 'Reassigned to '+getStaffName(assignmentData.assigned_to, StaffManagement)
                }
                return 'Assigned to '+getStaffName(assignmentData.assigned_to, StaffManagement)
            }   
        }
        else{
            return 'Assigned to other staff no longer needs attention';
        }
    }else{
        return 'Resolved and no longer needs attention';
    }
}
const isBlockedOrOptOut=(conversation,blockedNumbers,optoutnumbers)=>{
    let status = {
        blocked:false,
        optout:false
    }
    const isBlocked = blockedNumbers? blockedNumbers.filter(number=>number.user_phone === conversation.userPhone):[];
    const isOptout = optoutnumbers && optoutnumbers.recent_n_details? optoutnumbers.recent_n_details.filter(number=>number.phone_number === conversation.userPhone):[];
    if(isBlocked && isBlocked.length>0){
        status.blocked = true;
    }
    if(isOptout && isOptout.length>0){
        status.optout = true;
    }
    return status
}

const ConversationList = ({conversation,auth,typeofUser,selectedConversation, selectConversation, removeConversation, addOnNotEnabled, isNextElement, markResolved, activeCategory, allAssignmentMap, StaffManagement, transitioned,assignmentData, blockedNumbers,optoutnumbers}) => {
    const conversationStatus = helpers.getConversationStatus(conversation);
    const name = helpers.getclientNameListMeta(conversation, typeofUser);
    const phone = helpers.getClientPhone(conversation);
    const assignedList = allAssignmentMap.filter(assignment=>assignment.assigned_user===conversation.userId);
    const assignedTo = assignedList.length>0?assignedList[0].assigned_to:null;
    const { list } = StaffManagement;
    const logoName = helpers.getLogoName(assignedTo,list, allAssignmentMap);
    const blockStatus = isBlockedOrOptOut(conversation,blockedNumbers,optoutnumbers);
    const newConversationRef = useRef(null);
    useEffect(()=>{
        if(conversation.staffCreated){
        setTimeout(()=>{
            newConversationRef.current.scrollIntoView({behavior:"smooth",block: "end"});
          })
        }
      },[conversation])
    
  return (<div className={cx("conversation-card",{'active-conversation': (!utils.isEmptyObject(selectedConversation) && conversation && conversation.id==selectedConversation.id),'next-active-element':isNextElement===true})} onClick={()=>selectConversation(conversation)}>
            
            {(isTransitoned(conversation.id,transitioned) && activeCategory!==null)?
            (<div className="conversation-card_resolved">
                <i className="material-icons">check</i>
               <div className="title">{getTransitionMessage(conversation,markResolved, assignmentData, StaffManagement, auth, allAssignmentMap, addOnNotEnabled)}</div>
            </div>):
            (
            <>{conversation.staffCreated?
            (<div className="conversation-card_new" ref={newConversationRef}>
               <div className="title"> New Conversation</div>
               <div className="cls-btn" onClick={()=>removeConversation(conversation.id)}><img src={closeBlue}/></div>
            </div>):
            (<>
            {!addOnNotEnabled && 
            <div className="conversation-card_status">
                {assignedTo?
                 (logoName?(<div className="logo">{logoName}</div>):(<div className="logo"><img src={Profile} /></div>))
                  :(<div className="icon-container"><img src={Logo} />
                </div>)}
                
            </div>}
            <div className="conversation-card_details">
                <div className="conversation-card_details_nameandphone">
                    <div className="namephonecontainer">
                    <div className="user-name">
                        {name}
                    </div>
                    {/* {conversation.textType!=="WEBCHAT" && */}
                    <div className="user-phone">
                        {helpers.abbrivateString(phone,35-name.length)}
                    </div>
                    {/* } */}
                    {blockStatus.blocked &&<div className="blocked-number"><span className="icon-ellipse-container"><img className="ellipse" src={Ellipse}/><img className="line" src={Line}/></span></div>}
                    {blockStatus.optout &&<div className="blocked-number"><span className="icon-ellipse-container"><img className="optout1" src={optout_1}/><img className="optout2" src={optout_2}/></span></div>}
                            
                    </div>
                    {conversation.unread_count>0 &&
                    <div className="count-container">
                        <div className="count">{conversation.unread_count}</div>
                    </div>
                    }
                </div>
                <div className="conversation-card_details_tags">
                    <div className="conversation-start-time">
                        {getLocalTimeFromNow(conversation)}
                    </div>
                    {conversation.tags && conversation.tags.includes('HAS_VOICE_MAIL') &&
                    <>
                        <div className="dot-seperator"></div>
                        <div className="conversation-voice-mail">
                            <i className="material-icons">voicemail</i>
                        </div>
                    </>
                    }
                    {conversation.tags && conversation.tags.includes('HAS_VOICE_CALL') &&
                                  <>
                                      <div className="dot-seperator"></div>
                                      <div className="conversation-voice-mail">
                                      <img src={Voicecall} />
                                      </div>
                                  </>
                    }
                    {(conversationStatus.value!=='NONE' || conversation.auto_chat_status==='PAUSED') && 
                    <>
                    <div className="dot-seperator"></div>
                    {conversation.action==='FOLLOWUP_NEEDED'?
                    (
                    <div className="conversation-status">
                        {conversationStatus.label}
                    </div>):(<>
                        {conversation.auto_chat_status==='PAUSED'?
                        (<div className="conversation-status paused">
                        TrueLark paused
                        </div>):(
                            <div className="conversation-status resolved">
                            {conversationStatus.label}
                        </div>
                        )}
            
                    </>)}
                    </>
                    }
                </div>
            </div>
            </>)
        }</>)}
        </div>);
};

export default ConversationList;
